import { combineReducers } from "@reduxjs/toolkit";

import {
	orderMapDataState,
	orderMapDataReducer,
	orderMapDataAction,
} from "./data";
import {
	orderMapFiltersState,
	orderMapFiltersReducer,
	orderMapFiltersAction,
} from "./filter";
import {
	orderMapTogglesState,
	orderMapTogglesReducer,
	orderMapTogglesAction,
} from "./toggles";

export type StateMap = {
	data: orderMapDataState;
	filter: orderMapFiltersState;
	toggles: orderMapTogglesState;
};

export const map = combineReducers<StateMap>({
	data: orderMapDataReducer,
	filter: orderMapFiltersReducer,
	toggles: orderMapTogglesReducer,
});

export const ordersMapAction = {
	data: orderMapDataAction,
	filter: orderMapFiltersAction,
	toggles: orderMapTogglesAction,
};

export default map;
